import { exitMaintenance } from '../../../../actions/maintenanceActions';

export default function IndicatorHandler(store, status){
  switch(status.IndicatorService){
    case 'HEALTHY':

      break;

    case 'FATAL':
    case 'UNKNOWN':
      if(store.getState().maintenance.active)
        store.dispatch(exitMaintenance())
      break;

    default:
      console.error('STATUS NOT REGISTERED')
  }
}